export type InstallEnvironment = 'telegram' | 'ios' | 'browser';

export function detectInstallEnvironment(
  userAgent: string,
  platform = '',
  maxTouchPoints = 0
): InstallEnvironment {
  const ua = userAgent.toLowerCase();
  const isIos = /iphone|ipad|ipod/.test(ua) || (platform === 'MacIntel' && maxTouchPoints > 1);
  const isTelegram = /telegram|tgwebview/.test(ua);
  const isAndroidWebView = /\bwv\b|; wv\)/.test(ua);
  const isIosWebView = isIos && !/safari/.test(ua);

  if (isTelegram || isAndroidWebView || isIosWebView) return 'telegram';
  if (isIos) return 'ios';
  return 'browser';
}

export function isStandaloneDisplay(): boolean {
  const iosNavigator = navigator as Navigator & { standalone?: boolean };
  return window.matchMedia('(display-mode: standalone)').matches || iosNavigator.standalone === true;
}
